import React, { useEffect, useState } from "react";
import TextField from "@/src/components/custom-fields/TextField";
import { homeApiService } from "@/src/lib/api-services/homeApiServices";
import Progressbar from "../loading";
import { formatTimeSlot } from "../common/common";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import CustomButton from "@/src/lib/ui/Button";
import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";

export default function NextAvailability({ handlePincodeChange, pincode }) {
    const [earliestTime, setEarliestTime] = useState(null);
    const [pinCode, setPinCode] = useState(pincode);
    const [finalPincode, setFinalPincode] = useState(pinCode);

    const { data, isLoading, refetch } = useCustomQuery(
        ["home_slot_availability", finalPincode],
        () => homeApiService.getHomeEarliestAvailableSlots(finalPincode),
        {
            enabled: !!finalPincode,
        }
    );

    useEffect(() => {
        if (data) {
            setEarliestTime(getEarliestAvailability(data));
        } else {
            setEarliestTime(null);
        }
    }, [data]);

    // useEffect(() => {
    //     handleCheckAvailability();
    // }, []);

    const getEarliestAvailability = (availability) => {
        const earliestDate = availability[0]?.dates1;
        const earliestTime = availability[0]?.Times?.split(",")[0];
        const slotTime = availability[0]?.slotWidth;

        if (!earliestDate && !earliestTime) {
            return null;
        }

        return `${earliestDate} ${earliestTime} ${slotTime}`;
    };

    const handleCheckAvailability = () => {
        if (pinCode?.trim()) {
            setFinalPincode(pinCode);
            handlePincodeChange(pinCode?.trim());
        }
    };

    return (
        <>
            <div className="w-full rounded-lg border border-solid border-slate-200 bg-slate-50 p-4">
                <p className="mb-1.5 text-sm font-medium text-slate-700">
                    Check home collection availability
                </p>
                <div className="flex w-full flex-row gap-2">
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Pin Code"
                        value={pinCode}
                        onChange={(e) => setPinCode(e.target.value)}
                    />

                    <CustomButton
                        className="shrink-0 capitalize"
                        variant="outlined"
                        color="primary"
                        style={{ borderRadius: 8, fontWeight: 600 }}
                        onClick={handleCheckAvailability}
                        disabled={pinCode?.trim()?.length != 6}
                    >
                        Check
                    </CustomButton>
                </div>
                <div className="mt-3">
                    {isLoading ? (
                        <div className="flex items-center gap-2">
                            <Progressbar size={12} />
                            <p className="text-sm text-slate-500">
                                Checking availability…
                            </p>
                        </div>
                    ) : earliestTime ? (
                        <div className="flex items-start gap-2 rounded-md bg-emerald-50 px-3 py-2 ring-1 ring-emerald-100">
                            <Iconify
                                icon={IconCode.checkCircle}
                                width={18}
                                className="mt-0.5 shrink-0 text-emerald-600"
                            />
                            <div>
                                <p className="text-xs text-emerald-800">
                                    {`Earliest Home Pickup @ ${finalPincode}:`}
                                </p>
                                <p className="text-sm font-semibold text-emerald-900">
                                    {`${earliestTime.split(" ")[0]} `}
                                    {formatTimeSlot(
                                        earliestTime.split(" ")[1],
                                        earliestTime.split(" ")[2]
                                    )}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center gap-2 rounded-md bg-rose-50 px-3 py-2 ring-1 ring-rose-100">
                            <Iconify
                                icon={IconCode.biInfoCircle}
                                width={18}
                                className="shrink-0 text-rose-600"
                            />
                            <p className="text-sm text-rose-700">
                                Service not Available
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
